import { render, staticRenderFns } from "./EntryPlatform.vue?vue&type=template&id=dbbdcb2e&scoped=true"
import script from "./EntryPlatform.vue?vue&type=script&lang=js"
export * from "./EntryPlatform.vue?vue&type=script&lang=js"
import style0 from "./EntryPlatform.vue?vue&type=style&index=0&id=dbbdcb2e&prod&scoped=true&lang=css"
import style1 from "./EntryPlatform.vue?vue&type=style&index=1&id=dbbdcb2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbdcb2e",
  null
  
)

export default component.exports